import{parseScope as e}from"./parse-scope.mjs";const t=(...t)=>t.flatMap(t=>e(t));export{t as mergeScopes};
//# sourceMappingURL=merge-scopes.mjs.map